import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../useApiQuery';

// we provide the showId to be backwards compatible with the old useGetShowOwnerAccess hook
const useGetNetworkAccess = ({
  networkId: networkIdParam,
  showId: showIdParam,
  disabled = false,
} = {}) => {
  const { showId: currentShowId, networkId: currentNetworkId } = useParams();
  const showId = currentShowId || showIdParam;
  const networkId = currentNetworkId || networkIdParam;

  const query = useApiQuery({
    queryKey: keys.networkAccess({ networkId, showId }),
    requestUrl: `/networks/${networkId}/access${showId ? `?showId=${showId}` : ''}`,
    disabled: !networkId || disabled,
  });

  return {
    networkAccessData: query.data,
    networkAccessError: query.error,
    isNetworkAccessFetchError: query.isError,
    isNetworkAccessFetchSuccess: query.isSuccess,
    isNetworkAccessFetching: query.isFetching,
    isNetworkAccessLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetNetworkAccess;
